import { render } from "./index.vue?vue&type=template&id=168c4ea2&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=168c4ea2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-168c4ea2"

export default script